import React from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
};

export const InvoiceRecipientNameFormField = React.forwardRef(
  function InvoiceRecipientNameFormField(
    props: Props,
    ref: React.ForwardedRef<HTMLInputElement>
  ) {
    const isSpMode = useIsSpMode();
    return (
      <div css={!isSpMode ? container : {}}>
        <div css={labelWrapper}>
          <Font variant="m" component="p">
            宛名
          </Font>
        </div>
        <div css={inputWrapper}>
          <FormTextField name={props.name} ref={ref} />
          <div css={errorWrapper}>
            <FormErrorMessage name={props.name} />
          </div>
        </div>
      </div>
    );
  }
);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "80px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const errorWrapper = css({
  flex: 1,
});
